// React
import React from 'react';

// React-router
import { Link } from 'react-router-dom';

// Style
import './style.sass';

// Images
const newsImage = require('assets/images/NewDesign/Home/third-section/hexagon images/diario.jpg');
const hardwareImage = require('assets/images/NewDesign/Home/third-section/hexagon images/maquinas.jpg');
const talkingImage = require('assets/images/NewDesign/Home/third-section/hexagon images/conversacion.jpg');
const pressImage = require('assets/images/NewDesign/Home/third-section/hexagon images/prensa.jpg');
const developImage = require('assets/images/NewDesign/Home/third-section/hexagon images/graficas.jpg');
const aboutImage = require('assets/images/NewDesign/Home/third-section/hexagon images/saludos.jpg');
const metoImage = require('assets/images/NewDesign/Home/third-section/hexagon images/metodologia.jpg');
const eyeGif = require('assets/images/NewDesign/Home/third-section/hexagon images/eyes-gif/eye.gif');

class BigHexagon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.metodologiaHex = React.createRef();

    this.traccionImageHex = React.createRef();
    this.traccionCoverHex = React.createRef();
    this.traccionText = React.createRef();

    this.hardwareImageHex = React.createRef();
    this.hardwareCoverHex = React.createRef();
    this.hardwareText = React.createRef();

    this.asesoriaImageHex = React.createRef();
    this.asesoriaCoverHex = React.createRef();
    this.asesoriaText = React.createRef();

    this.first = React.createRef();
    this.firstSecond = React.createRef();
    this.metoText = React.createRef();

    this.pressImageHex = React.createRef();
    this.pressCoverHex = React.createRef();
    this.pressText = React.createRef();

    this.nosotrosImageHex = React.createRef();
    this.nosotrosCoverHex = React.createRef();
    this.nosotrosText = React.createRef();

    // this.investigationImageHex = React.createRef();
    this.investigationCoverHex = React.createRef();
    this.investigationText = React.createRef();
  }

  componentDidMount = () => {
    // gsap.registerPlugin(ScrollTrigger);
    // const tline = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: this.metodologiaHex.current,
    //         start: "top 100%",
    //         end: "top 100%",
    //         scrub: 2,
    //     }
    // });
    // tline.from([this.traccionImageHex.current, this.traccionCoverHex.current, this.traccionText.current], {opacity: 0});
    // tline.from([this.hardwareImageHex.current, this.hardwareCoverHex.current, this.hardwareText.current], {opacity: 0});
    // tline.from([this.asesoriaImageHex.current, this.asesoriaCoverHex.current, this.asesoriaText.current], {opacity: 0});
    // tline.from([this.first.current, this.firstSecond.current, this.metoText.current], {opacity: 0, duration: 1});
    // tline.from([this.pressImageHex.current, this.pressCoverHex.current, this.pressText.current], {opacity: 0});
    // tline.from([this.nosotrosImageHex.current, this.nosotrosCoverHex.current, this.nosotrosText.current], {opacity: 0});
    // tline.from([this.investigationImageHex.current, this.investigationCoverHex.current, this.investigationText.current], {opacity: 0});
  };

  render() {
    const { t } = this.props;
    return (
      <div className='service-hexagon-wrapper' ref={this.metodologiaHex}>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 765 797'>
          <defs>
            <pattern
              id='newsImage'
              patternUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1000'
              height='700'
            >
              <image
                href={newsImage}
                width='289'
                height='289'
                preserveAspectRatio='xMinYMin slice'
                alt=''
              />
            </pattern>

            <pattern
              id='hardwareImage'
              patternUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1000'
              height='700'
            >
              <image
                href={hardwareImage}
                width='289'
                height='289'
                preserveAspectRatio='xMinYMin slice'
              />
            </pattern>

            <pattern
              id='talkingImage'
              patternUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1000'
              height='700'
            >
              <image
                href={talkingImage}
                width='289'
                height='289'
                preserveAspectRatio='xMinYMin slice'
              />
            </pattern>

            <pattern
              id='pressImage'
              patternUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1000'
              height='700'
            >
              <image
                href={pressImage}
                width='289'
                height='289'
                preserveAspectRatio='xMinYMin slice'
              />
            </pattern>

            <pattern
              id='developImage'
              patternUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1000'
              height='700'
            >
              <image
                href={developImage}
                width='289'
                height='289'
                preserveAspectRatio='xMinYMin slice'
              />
            </pattern>

            <pattern
              id='aboutImage'
              patternUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1000'
              height='700'
            >
              <image
                href={aboutImage}
                width='289'
                height='289'
                preserveAspectRatio='xMinYMin slice'
              />
            </pattern>

            <pattern
              id='eyeGif'
              patternUnits='userSpaceOnUse'
              x='0'
              y='-20'
              width='300'
              height='300'
            >
              <image
                href={eyeGif}
                width='289'
                height='289'
                preserveAspectRatio='xMidYMin meet'
              />
            </pattern>

            <pattern
              id='metoImage'
              patternUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1000'
              height='700'
            >
              <image
                href={metoImage}
                width='289'
                height='289'
                preserveAspectRatio='xMinYMin slice'
              />
            </pattern>
          </defs>
          <g
            id='Grupo_247'
            data-name='Grupo 247'
            transform='translate(-258 -1136)'
          >
            <path
              id='Polígono_2'
              stroke='#3d4df3'
              data-name='Polígono 2'
              className='meto'
              d='M216.75 0 289 125l-72.25 125H72.25L0 125 72.25 0z'
              transform='translate(496 1410)'
              ref={this.first}
              style={{ opacity: '.8', fill: '#141414' }}
            />
            {/* <path id="Polígono_2" data-name="Polígono 2" className="meto_cover" d="M216.75 0 289 125l-72.25 125H72.25L0 125 72.25 0z" transform="translate(496 1410)" ref={this.firstSecond} style={{fill: "url(#eyeGif)"}} /> */}
            <path
              id='Polígono_1'
              data-name='Polígono 1'
              className='cls-2 traccion'
              ref={this.traccionImageHex}
              d='M216.75 0 289 124.5 216.75 249H72.25L0 124.5 72.25 0z'
              style={{ fill: 'url(#aboutImage)' }}
              transform='translate(496 1136)'
            />
            <path
              id='Polígono_1'
              data-name='Polígono 1'
              className='cls-2 traccion_cover'
              ref={this.traccionCoverHex}
              d='M216.75 0 289 124.5 216.75 249H72.25L0 124.5 72.25 0z'
              style={{ opacity: 0.8 }}
              transform='translate(496 1136)'
            />
            {/* <Link to="/about"><text id="TRACCIÓN" className="cls-3-text about-hex-text" ref={this.traccionText} transform="translate(641 1269)"><tspan x="-95.064" y="0">{t('c1do1Black.thirdSection.fourthHex')}</tspan></text></Link> */}
            {/* <path id="Polígono_7" data-name="Polígono 7" ref={this.investigationImageHex} className="cls-4 investigation" d="M216.75 0 289 124.5 216.75 249H72.25L0 124.5 72.25 0z" style={{fill: "url(#developImage)"}} transform="translate(496 1684)"/>
                        <path id="Polígono_7" data-name="Polígono 7" ref={this.investigationCoverHex} className="cls-4 investigation_cover" d="M216.75 0 289 124.5 216.75 249H72.25L0 124.5 72.25 0z" style={{opacity: 0.8}} transform="translate(496 1684)"/> */}
            {/* <Link to="/investigation"><text id="I_D" data-name="I+D" ref={this.investigationText} className="cls-3-text press-hex-text" transform="translate(641 1817)"><tspan x="-17.64" y="0">I+D</tspan></text></Link> */}
            <path
              id='Polígono_3'
              data-name='Polígono 3'
              className='cls-5 hardware'
              ref={this.hardwareImageHex}
              d='M217.5 0 290 124.5 217.5 249h-145L0 124.5 72.5 0z'
              style={{ fill: 'url(#metoImage)' }}
              transform='translate(258 1271)'
            />
            <path
              id='Polígono_3'
              data-name='Polígono 3'
              className='cls-5 hardware_cover'
              ref={this.hardwareCoverHex}
              d='M217.5 0 290 124.5 217.5 249h-145L0 124.5 72.5 0z'
              style={{ opacity: 0.8 }}
              transform='translate(258 1271)'
            />
            <Link to='/methodology'>
              <text
                id='HARDWARE'
                className='cls-3-text about-hex-text'
                ref={this.hardwareText}
                transform='translate(403 1404)'
              >
                <tspan x={t('c1do1Black.thirdSection.centerHexAMargin')} y='-15'>
                  {t('c1do1Black.thirdSection.centerHexA')}
                </tspan>
                <tspan x={t('c1do1Black.thirdSection.centerHexBMargin')} y='18'>
                  {t('c1do1Black.thirdSection.centerHexB')}
                </tspan>
              </text>
            </Link>
            <path
              id='Polígono_6'
              data-name='Polígono 6'
              className='cls-2 press'
              ref={this.pressImageHex}
              d='M217.5 0 290 125l-72.5 125h-145L0 125 72.5 0z'
              style={{ fill: 'url(#pressImage)' }}
              transform='translate(258 1550)'
            />
            <path
              id='Polígono_6'
              data-name='Polígono 6'
              className='cls-2 press_cover'
              ref={this.pressCoverHex}
              d='M217.5 0 290 125l-72.5 125h-145L0 125 72.5 0z'
              style={{ opacity: 0.8 }}
              transform='translate(258 1550)'
            />
            {/* <Link to="/press"><text id="NOTICIAS_Y_PRENSA" data-name="NOTICIAS Y PRENSA" className="cls-3-text press-hex-text" ref={this.pressText} transform="translate(403 1665)"><tspan x={`${localStorage.getItem('language') === 'en' ? "-28.864" : "-48.864"}`} y="0">{t('c1do1Black.thirdSection.thirdHexA')}</tspan><tspan x={`${localStorage.getItem('language') === 'en' ? "-52.2" : "-52.2"}`} y="38">{t('c1do1Black.thirdSection.thirdHexB')}</tspan></text></Link> */}
            {/* <text id="METODOLOGÍA_C1DO1" data-name="METODOLOGÍA C1DO1" ref={this.metoText} className="cls-3-text" transform="translate(640 1525)"><tspan x="-77.64" y="0">{t('c1do1Black.thirdSection.centerHexA')}</tspan><tspan x="-35.532" y="38">{t('c1do1Black.thirdSection.centerHexB')}</tspan></text> */}
            <path
              id='Polígono_4'
              data-name='Polígono 4'
              ref={this.asesoriaImageHex}
              className='cls-4 talking'
              d='M217.5 0 290 124.5 217.5 249h-145L0 124.5 72.5 0z'
              style={{ fill: 'url(#developImage)' }}
              transform='translate(733 1271)'
            />
            <path
              id='Polígono_4'
              data-name='Polígono 4'
              ref={this.asesoriaCoverHex}
              className='cls-4 talking_cover'
              d='M217.5 0 290 124.5 217.5 249h-145L0 124.5 72.5 0z'
              style={{ opacity: 0.8 }}
              transform='translate(733 1271)'
            />

            {/* <Link  to="/investigation"><text id="ASESORÍA" ref={this.asesoriaText} className="cls-3-text about-hex-text" transform="translate(878 1404)"><tspan x="-15.476" y="0">R+D</tspan></text></Link> */}
            <path
              id='Polígono_65'
              data-name='Polígono 65'
              ref={this.nosotrosImageHex}
              className='cls-5 about'
              d='M217.5 0 290 125l-72.5 125h-145L0 125 72.5 0z'
              style={{ fill: 'url(#hardwareImage)' }}
              transform='translate(733 1550)'
            />
            <path
              id='Polígono_65'
              data-name='Polígono 65'
              ref={this.nosotrosCoverHex}
              className='cls-5 about_cover'
              d='M217.5 0 290 125l-72.5 125h-145L0 125 72.5 0z'
              style={{ opacity: 0.8 }}
              transform='translate(733 1550)'
            />
            <Link to='/lapp'>
              <text
                id='IA'
                className='cls-3-text about-hex-text'
                ref={this.nosotrosText}
                transform='translate(878 1683)'
              >
                <tspan x='-60.416' y='0'>
                  C1DO1 LAPP
                </tspan>
              </text>
            </Link>
          </g>
          <foreignObject x='235' y='87' width='600' height='150'>
            <div
              xmlns='http://www.w3.org/1999/xhtml'
              style={{
                width: '300px',
                height: 'auto',
                fontSize: '24px',
                overflow: ' ',
                paddingTop: '.5%',
                color: '#fff',
              }}
            >
              <Link to='/about'>
                <p
                  ref={this.traccionText}
                  className='cls-3-text about-hex-text'
                  style={{
                    fontFamily: 'Titillium Web, sans-serif !important',
                    fontWeight: '600',
                    color: '#fff',
                    textAlign: 'center',
                  }}
                >
                  {t('c1do1Black.thirdSection.fourthHex')}
                </p>
              </Link>
            </div>
          </foreignObject>

          <foreignObject x='-10' y='380' width='600' height='350'>
            <Link to='/press'>
              <div
                xmlns='http://www.w3.org/1999/xhtml'
                style={{
                  width: '300px',
                  height: '300px',
                  fontSize: '24px',
                  overflow: ' ',
                  color: '#fff',
                  paddingTop: '17%',

                  fontFamily: 'Titillium Web, sans-serif !important',
                }}
              >
                <p
                  ref={this.traccionText}
                  className='cls-3-text about-hex-text'
                  style={{
                    color: '#fff',
                    fontWeight: '600',
                    fontFamily: 'Titillium Web, sans-serif',
                    textAlign: 'center',
                    marginBottom: '0px',
                  }}
                >
                  {t('c1do1Black.thirdSection.thirdHexA')}
                </p>
                <p
                  ref={this.traccionText}
                  className='cls-3-text about-hex-text'
                  style={{
                    color: '#fff',
                    fontWeight: '600',
                    fontFamily: 'Titillium Web, sans-serif',
                    textAlign: 'center',
                    marginTop: '0px',
                  }}
                >
                  {t('c1do1Black.thirdSection.thirdHexB')}
                </p>
              </div>
            </Link>
          </foreignObject>

          <foreignObject x='475' y='150' width='600' height='350'>
            <Link to='/investigation'>
              <div
                xmlns='http://www.w3.org/1999/xhtml'
                style={{
                  width: '300px',
                  height: '200px',
                  fontSize: '24px',
                  overflow: ' ',
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',

                  fontFamily: 'Titillium Web, sans-serif !important',
                }}
              >
                <p
                  ref={this.traccionText}
                  className='cls-3-text about-hex-text'
                  style={{
                    color: '#fff',
                    fontFamily: 'Titillium Web, sans-serif !important',
                    fontWeight: '600',
                    textAlign: 'center',
                    marginBottom: '0px',
                  }}
                >
                  {t('c1do1Black.thirdSection.investigation')}
                </p>
              </div>
            </Link>
          </foreignObject>

          <foreignObject x='290' y='308.5' width='180' height='180'>
            <div
              xmlns='http://www.w3.org/1999/xhtml'
              style={{
                width: 'max-content',
                height: 'auto',
              }}
            >
              <img style={{ width: '180px', height: '180px' }} src={eyeGif} alt=''/>
            </div>
          </foreignObject>
        </svg>
      </div>
    );
  }
}

export default BigHexagon;
